import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'real-time-notifications',
  templateUrl: './real-time-notifications.component.html',
  styleUrls: ['./real-time-notifications.component.css']
})
export class RealTimeNotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
